(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
(()=>{
  const header=document.querySelector('[data-ls-header]');
  if(!header)return;
  const wordmark=header.querySelector('.ls-header__wordmark');
  const isLanding=header.dataset.landing==='true';
  let solid=!isLanding;
  const setSolid=next=>{
    if(next===solid)return;
    solid=next;
    header.classList.toggle('is-solid',next);
    wordmark.classList.remove('is-bouncing');
    void wordmark.offsetWidth;
    wordmark.classList.add('is-bouncing');
    window.setTimeout(()=>wordmark.classList.remove('is-bouncing'),620);
  };
  if(isLanding){
    const hero=document.querySelector('#inicio');
    if(hero){
      const update=()=>setSolid(hero.getBoundingClientRect().bottom<=header.offsetHeight+2);
      update();
      addEventListener('scroll',update,{passive:true});
      addEventListener('resize',update,{passive:true});
    }
  }
  const menu=document.querySelector('#LowsideMenu');
  const search=document.querySelector('#LowsideSearch');
  const scrim=document.querySelector('[data-ls-drawer-scrim]');
  const setDrawer=(drawer,open)=>{
    [menu,search].forEach(item=>{if(item!==drawer)item.classList.remove('is-open')});
    drawer.classList.toggle('is-open',open);
    drawer.setAttribute('aria-hidden',String(!open));
    document.documentElement.classList.toggle('ls-drawer-lock',open);
    scrim.hidden=!open;
    document.querySelectorAll(drawer===menu?'[data-ls-menu-open]':'[data-ls-search-open]').forEach(button=>button.setAttribute('aria-expanded',String(open)));
    if(open&&drawer===search)requestAnimationFrame(()=>search.querySelector('input')?.focus());
  };
  document.querySelectorAll('[data-ls-menu-open]').forEach(button=>button.addEventListener('click',()=>setDrawer(menu,true)));
  document.querySelectorAll('[data-ls-search-open]').forEach(button=>button.addEventListener('click',()=>setDrawer(search,true)));
  document.querySelector('[data-ls-menu-close]')?.addEventListener('click',()=>setDrawer(menu,false));
  document.querySelector('[data-ls-search-close]')?.addEventListener('click',()=>setDrawer(search,false));
  scrim.addEventListener('click',()=>{setDrawer(menu,false);setDrawer(search,false)});
  addEventListener('keydown',event=>{if(event.key==='Escape'){setDrawer(menu,false);setDrawer(search,false)}});

  const form=search.querySelector('form[role="search"]');
  const input=search.querySelector('[data-ls-search-input]');
  const grid=search.querySelector('[data-ls-search-results]');
  const label=search.querySelector('[data-ls-search-label]');
  const empty=search.querySelector('[data-ls-search-empty]');
  const seed=grid.innerHTML;
  const aliases={
    zapatilla:'sneakers',zapatillas:'sneakers',tenis:'sneakers',
    buzo:'hoodie',buzos:'hoodie',sudadera:'hoodie',sudaderas:'hoodie',
    jacket:'chaqueta',jackets:'chaqueta',chaquetas:'chaqueta',
    tshirt:'camiseta',tshirts:'camiseta',tee:'camiseta',tees:'camiseta',camisetas:'camiseta',
    pants:'pantalon',pantalones:'pantalon',
    cap:'gorra',caps:'gorra',gorras:'gorra',
    preventa:'preorden',reserva:'preorden',
    oferta:'descuento',ofertas:'descuento',rebaja:'descuento',rebajas:'descuento',
    nuevos:'nuevo',novedades:'nuevo',
    women:'genero-mujer',womens:'genero-mujer',femenino:'genero-mujer',
    men:'genero-hombre',mens:'genero-hombre',masculino:'genero-hombre'
  };
  const escapeHtml=value=>String(value||'').replace(/[&<>'"]/g,char=>({'&':'&amp;','<':'&lt;','>':'&gt;',"'":'&#39;','"':'&quot;'}[char]));
  const fold=value=>String(value||'').normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase().trim();
  const tokens=value=>fold(value).split(/\s+/).filter(Boolean);
  const canonicalQuery=value=>tokens(value).map(token=>aliases[token]||token).join(' ');
  const stripHtml=value=>String(value||'').replace(/<[^>]*>/g,' ');
  const money=value=>new Intl.NumberFormat('es-CO',{style:'currency',currency:'COP',maximumFractionDigits:0}).format(Number(value||0));
  const productText=product=>fold([
    product.title,
    product.vendor,
    product.type,
    ...(product.tags||[]),
    stripHtml(product.body),
    ...((product.variants||[]).flatMap(variant=>[variant.title,variant.sku,variant.barcode]))
  ].filter(Boolean).join(' '));
  const scoreProduct=(product,term,index)=>{
    const query=fold(term);
    const queryTokens=tokens(term);
    const title=fold(product.title);
    const vendor=fold(product.vendor);
    const type=fold(product.type);
    const tags=(product.tags||[]).map(fold);
    const haystack=productText(product);
    let score=Math.max(0,40-index);
    if(title===query)score+=520;
    else if(title.startsWith(query))score+=340;
    else if(title.includes(query))score+=220;
    if(vendor===query)score+=300;
    else if(vendor.startsWith(query))score+=180;
    if(type===query)score+=210;
    else if(type.includes(query))score+=120;
    if(tags.includes(query))score+=240;
    if(queryTokens.length&&queryTokens.every(token=>haystack.includes(token)))score+=140;
    if(product.available)score+=25;
    return score;
  };
  const card=(product,price=money(product.price))=>{
    const image=typeof product.featured_image==='string'?product.featured_image:product.featured_image?.url;
    const unavailable=product.available===false?'<em class="ls-search-card__soldout">Agotado</em>':'';
    return `<a class="ls-search-card" href="${escapeHtml(product.url)}"><span>${image?`<img src="${escapeHtml(image)}" alt="${escapeHtml(product.title)}" loading="lazy">`:''}</span><small>${escapeHtml(product.vendor)}</small><strong>${escapeHtml(product.title)}</strong><b>${price}</b>${unavailable}</a>`;
  };
  let related=[];
  let timer;
  let controller;
  let lastResultCount=0;
  let lastResolvedTerm='';
  const variantCardCache=new Map();
  const syncSearchCards=()=>{
    grid.querySelectorAll('a.ls-search-card').forEach(link=>{
      const url=new URL(link.href,location.origin);
      const key=url.pathname;
      if(!key.includes('/products/')||link.dataset.lsVariantReady==='true')return;
      if(!variantCardCache.has(key)){
        const endpoint=new URL(key,location.origin);
        endpoint.searchParams.set('view','lowside-card-data');
        variantCardCache.set(key,fetch(endpoint,{credentials:'same-origin'}).then(r=>{if(!r.ok)throw new Error('Variant data unavailable');return r.json()}).catch(()=>null));
      }
      const ready=variantCardCache.get(key).then(data=>{
        if(!data?.variant_id)return;
        url.searchParams.set('variant',String(data.variant_id));
        link.href=url.pathname+url.search;
        const image=link.querySelector('img');
        if(image&&data.image){image.removeAttribute('srcset');image.removeAttribute('sizes');image.src=data.image}
        const price=link.querySelector('b');
        if(price&&data.price_formatted)price.textContent=data.price_formatted;
        link.dataset.lsVariantReady='true';
      });
      if(!link.dataset.lsVariantBound){
        link.dataset.lsVariantBound='true';
        link.addEventListener('click',event=>{
          if(link.dataset.lsVariantReady==='true'||event.defaultPrevented||event.ctrlKey||event.metaKey||event.shiftKey)return;
          event.preventDefault();
          ready.then(()=>location.assign(link.href));
        });
      }
    });
  };
  const restore=()=>{
    const existing=new Set(Array.from(grid.querySelectorAll('a[href]')).map(link=>link.getAttribute('href')?.split('?')[0]));
    grid.innerHTML=seed;
    existing.clear();
    Array.from(grid.querySelectorAll('a[href]')).forEach(link=>existing.add(link.getAttribute('href')?.split('?')[0]));
    related.filter(product=>!existing.has(String(product.url||'').split('?')[0])).slice(0,6).forEach(product=>grid.insertAdjacentHTML('beforeend',card(product,money(Number(product.price||0)/100))));
    syncSearchCards();
    label.textContent='Entrega inmediata · Productos que te pueden interesar';
    empty.hidden=true;
    search.classList.remove('has-query','is-searching');
    lastResultCount=0;
    lastResolvedTerm='';
  };
  const fetchProducts=async(term,signal)=>{
    const root=window.Shopify?.routes?.root||'/';
    const params=new URLSearchParams();
    params.set('q',term);
    params.set('resources[type]','product');
    params.set('resources[limit]','10');
    params.set('resources[limit_scope]','each');
    params.set('resources[options][unavailable_products]','last');
    params.set('resources[options][fields]','title,product_type,variants.title,vendor,tag,variants.sku,variants.barcode,body');
    const response=await fetch(`${root}search/suggest.json?${params.toString()}`,{signal});
    if(!response.ok)throw new Error(String(response.status));
    const data=await response.json();
    return data.resources?.results?.products||[];
  };
  const runSearch=async(rawQuery)=>{
    controller?.abort();
    controller=new AbortController();
    const original=rawQuery.trim();
    const canonical=canonicalQuery(original);
    search.classList.add('has-query','is-searching');
    label.textContent='Buscando productos…';
    empty.hidden=true;
    try{
      let usedTerm=original;
      let products=await fetchProducts(original,controller.signal);
      if(!products.length&&canonical&&canonical!==fold(original)){
        usedTerm=canonical;
        products=await fetchProducts(canonical,controller.signal);
      }
      products=products
        .map((product,index)=>({product,index,score:scoreProduct(product,usedTerm,index)}))
        .sort((a,b)=>b.score-a.score||a.index-b.index)
        .map(item=>item.product);
      lastResultCount=products.length;
      lastResolvedTerm=usedTerm;
      grid.innerHTML=products.map(product=>card(product)).join('');
      syncSearchCards();
      label.textContent=products.length?`${products.length} resultados para “${original}”`:`Sin resultados para “${original}”`;
      empty.textContent=canonical!==fold(original)?`Tampoco encontramos coincidencias relacionadas con “${canonical}”.`:'Prueba con una marca, categoría, color, talla o una palabra más corta.';
      empty.hidden=products.length>0;
    }catch(error){
      if(error.name!=='AbortError'){
        lastResultCount=0;
        lastResolvedTerm='';
        grid.innerHTML='';
        label.textContent='No pudimos completar la búsqueda';
        empty.textContent='Intenta nuevamente en unos segundos.';
        empty.hidden=false;
      }
    }finally{
      search.classList.remove('is-searching');
    }
  };
  syncSearchCards();
  if(search.dataset.lsRelatedUrl){
    fetch(search.dataset.lsRelatedUrl).then(response=>response.ok?response.json():Promise.reject()).then(data=>{related=(data.products||[]).slice(0,6);restore()}).catch(()=>{});
  }
  input.addEventListener('input',()=>{
    clearTimeout(timer);
    const query=input.value.trim();
    if(!query){controller?.abort();restore();return}
    timer=setTimeout(()=>runSearch(query),180);
  });
  search.querySelectorAll('[data-ls-search-suggestion]').forEach(button=>button.addEventListener('click',()=>{
    input.value=button.dataset.lsSearchSuggestion||'';
    input.dispatchEvent(new Event('input',{bubbles:true}));
    input.focus();
  }));
  form?.addEventListener('submit',()=>{
    const target=lastResolvedTerm||canonicalQuery(input.value);
    if(target&&fold(target)!==fold(input.value))input.value=target;
  });
})();

  } catch(e) { console.error(e); }
})();
})();
